import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { FiTrendingUp } from "react-icons/fi";

import Button from "components/Button";
import ContributionModal from "./ContributionModal";
import IconBanner from "components/IconBanner";
import AddBankModal from "./AddBankModal";
import "./PriorYearContributionCard.scss";

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface PriorYearContributionAbility {
  taxYear?: number;
}

interface OwnProps {
  priorYearContributionAbility?: PriorYearContributionAbility;
  hasBankAccount?: boolean;
  bankAccount?: object;
  isSmallScreen?: boolean;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

interface State {
  showContributionModal: boolean;
  showBankModal: boolean;
}

class PriorYearContributionCard extends React.Component<Props, State> {
  constructor() {
    // preserved verbatim: original calls super()/constructor() with no args
    // even though React passes props — behavior unchanged on purpose.
    // @ts-expect-error original JS omits the props argument to super()
    super();

    this.state = {
      showContributionModal: false,
      showBankModal: false,
    };
  }

  _onContinueClick = () => {
    if (!this.props.hasBankAccount) {
      this.setState({
        showBankModal: true,
      });
      return;
    }
    this.setState({
      showContributionModal: true,
    });
  };

  _onFinishBankLinking = () => {
    this.setState({
      showBankModal: false,
      showContributionModal: true,
    });
  };

  _header = () => {
    const { taxYear } = this.props.priorYearContributionAbility!;
    return <>Would you like to contribute to your {taxYear} IRA?</>;
  };

  _subHeader = () => {
    const { taxYear } = this.props.priorYearContributionAbility!;
    return (
      <>
        You haven{"'"}t maxed out your contributions for your {taxYear} IRA yet.
        Make a contribution now to start investing!
      </>
    );
  };

  render() {
    const title = this._header();
    const subheader = this._subHeader();

    return (
      <>
        <div className="contribution-banner">
          <ContributionModal
            show={this.state.showContributionModal}
            options={{ isApplyToPriorYear: true }}
            onSuccess={() => {
              this.setState({ showContributionModal: false });
            }}
            onClose={() => {
              this.setState({ showContributionModal: false });
            }}
          />
          <AddBankModal
            show={this.state.showBankModal}
            onSuccess={this._onFinishBankLinking}
            onClose={() => {
              this.setState({ showBankModal: false });
            }}
          />

          <IconBanner
            icon={<FiTrendingUp color="white" stroke="#B12121" size={16} />}
            color="error"
            // @ts-expect-error IconBanner types title as string; original passes a JSX fragment (renders fine as ReactNode)
            title={title}
            subheader={subheader}
            actionComponent={
              <Button
                size="sm"
                name="action"
                color="action"
                btnLabel="Continue"
                onClick={this._onContinueClick}
              />
            }
          />
        </div>
      </>
    );
  }
}

export default connector(withApollo<Props>(PriorYearContributionCard));
